import { render, staticRenderFns } from "./UserAccessStatus.vue?vue&type=template&id=0cadc34f&"
import script from "./UserAccessStatus.vue?vue&type=script&lang=js&"
export * from "./UserAccessStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports